import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-1"}],["path",{"d":"M9 20.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75","key":"svg-2"}],["path",{"d":"M5 12v-7a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1","key":"svg-3"}],["path",{"d":"M3 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6m3 0l-2 -3","key":"svg-4"}]]

const IconFileTypeRs = createReactComponent('outline', 'file-type-rs', 'FileTypeRs', __iconNode);

export default IconFileTypeRs;